import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoInformePage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoInformePage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoInforme(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'TipoInforme', name: 'TipoInforme', title: 'Tipo de Informe',orderable: false },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tipoinformes: [],
            tipoinforme: {},
            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {
        newTipoInforme() {
            this.tipoinforme = {};
            this.$refs['frm-tipoinforme'].show();
        },
        showTipoInforme(id) {
            this.isLoading=true;
            this.ss.showTipoInforme(id).then(
                (result) => {
                    let response = result.data;
                    this.tipoinforme = response.data;
                    this.$refs['view-tipoinforme'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoInforme() {
            this.$refs['frm-tipoinforme'].show();
            this.$refs['view-tipoinforme'].hide();
        },
        cancelTipoInforme() {
            if (this.tipoinforme.id) {
                this.$refs['view-tipoinforme'].show();
            }
            this.$refs['frm-tipoinforme'].hide();
        },
        saveTipoInforme() {
            this.ss.storeTipoInforme(this.tipoinforme).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipoinforme'].hide();
                    this.$refs['datatable-tipoinforme'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoInforme() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                        this.ss.destroyTipoInforme(this.tipoinforme)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipoinforme'].hide();
                                this.$refs['datatable-tipoinforme'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoInforme').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoInforme(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
            this.$router.push('/Login');
        }else{
            this.auth = usuario;
        }
    }
};
